/* tslint:disable */
/* eslint-disable */
export enum SideAccessoryTypes {
  EavesBorder = 'eavesBorder',
  Gable = 'gable',
  GableCollector = 'gableCollector',
  GableUnderTile = 'gableUnderTile',
  Gutter = 'gutter',
  GutterHook = 'gutterHook',
  Ridge = 'ridge',
  RidgeClosing = 'ridgeClosing',
  RidgeMount = 'ridgeMount',
  RoofValley = 'roofValley',
  SnowStopper = 'snowStopper',
  SlopeBreakConcave = 'slopeBreakConcave',
  SlopeBreakConvex = 'slopeBreakConvex',
  TileBorderFixing = 'tileBorderFixing',
  WallBorder = 'wallBorder',
  WindbreakBase = 'windbreakBase'
}
